export default __webpack_public_path__ + "static/390be235-bf11-42ee-8ba1-2dd10ca6a4ac-2ea8a6db8505c1f04d30276c0aefb579.woff";